__turbopack_context__.v({
  "banksWrapper": "kRjLmG_banksWrapper",
  "centeredStep": "kRjLmG_centeredStep",
  "imageWrapper": "kRjLmG_imageWrapper",
  "logoWrapper": "kRjLmG_logoWrapper",
  "pageDescription": "kRjLmG_pageDescription",
  "paymentsWrapper": "kRjLmG_paymentsWrapper",
  "step": "kRjLmG_step",
  "stepDescription": "kRjLmG_stepDescription",
  "stepTitle": "kRjLmG_stepTitle",
});
